export default __webpack_public_path__ + "static/media/journeytray-greentree-fruit.d15fe00f.svg";